import { render, staticRenderFns } from "./V2ShipmentList.vue?vue&type=template&id=6d71dd4f&scoped=true&"
import script from "./V2ShipmentList.vue?vue&type=script&lang=js&"
export * from "./V2ShipmentList.vue?vue&type=script&lang=js&"
import style0 from "./V2ShipmentList.vue?vue&type=style&index=0&id=6d71dd4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71dd4f",
  null
  
)

export default component.exports